import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الموجة - احسب الطول الموجي، التردد، أو سرعة الموجة";
const DESCRIPTION =
  "حاسبة الموجة الشاملة: احسب الطول الموجي، التردد، أو سرعة الموجة باستخدام القيم المدخلة. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS =
  "الموجة, حساب الطول الموجي, حساب التردد, حساب سرعة الموجة, حاسبة الموجة";
const OG_URL = "https://do-calculate.com/calculator/ar/wave";
function WaveCalculator() {
  const [wavelength, setWavelength] = useState("");
  const [frequency, setFrequency] = useState("");
  const [waveSpeed, setWaveSpeed] = useState("");
  const [calculationMode, setCalculationMode] = useState("calculateWavelength");
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const wavelengthValue = parseFloat(wavelength) || 0;
    const frequencyValue = parseFloat(frequency) || 0;
    const waveSpeedValue = parseFloat(waveSpeed) || 0;
    switch (calculationMode) {
      case "calculateWavelength":
        if (waveSpeedValue > 0 && frequencyValue > 0) {
          const calculatedWavelength = waveSpeedValue / frequencyValue;
          setWavelength(Math.round(calculatedWavelength * 100) / 100);
        } else {
          setError("الرجاء إدخال سرعة الموجة والتردد بشكل صحيح");
        }
        break;
      case "calculateFrequency":
        if (waveSpeedValue > 0 && wavelengthValue > 0) {
          const calculatedFrequency = waveSpeedValue / wavelengthValue;
          setFrequency(Math.round(calculatedFrequency * 100) / 100);
        } else {
          setError("الرجاء إدخال سرعة الموجة والطول الموجي بشكل صحيح");
        }
        break;
      case "calculateWaveSpeed":
        if (wavelengthValue > 0 && frequencyValue > 0) {
          const calculatedWaveSpeed = wavelengthValue * frequencyValue;
          setWaveSpeed(Math.round(calculatedWaveSpeed * 100) / 100);
        } else {
          setError("الرجاء إدخال الطول الموجي والتردد بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [wavelength, frequency, waveSpeed, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handleWavelengthChange = (e) => setWavelength(e.target.value);
  const handleFrequencyChange = (e) => setFrequency(e.target.value);
  const handleWaveSpeedChange = (e) => setWaveSpeed(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculateWavelength":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الطول الموجي:</h4>
            <ol>
              <li>ادخل سرعة الموجة (بـ متر/ثانية) في الحقل المخصص.</li>
              <li>ادخل التردد (بـ هرتز) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الطول الموجي.</li>
              <li>الطول الموجي يساوي سرعة الموجة / التردد.</li>
            </ol>
          </div>
        );
      case "calculateFrequency":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب التردد:</h4>
            <ol>
              <li>ادخل سرعة الموجة (بـ متر/ثانية) في الحقل المخصص.</li>
              <li>ادخل الطول الموجي (بـ متر) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على التردد.</li>
              <li>التردد يساوي سرعة الموجة / الطول الموجي.</li>
            </ol>
          </div>
        );
      case "calculateWaveSpeed":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب سرعة الموجة:</h4>
            <ol>
              <li>ادخل الطول الموجي (بـ متر) في الحقل المخصص.</li>
              <li>ادخل التردد (بـ هرتز) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على سرعة الموجة.</li>
              <li>سرعة الموجة تساوي الطول الموجي × التردد.</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة الموجة إجراء ثلاث أنواع من الحسابات استنادًا إلى
                  القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل القيم المتوفرة
                  لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الطول الموجي بمعلومية سرعة الموجة والتردد
                </h2>
                <p>
                  إذا كنت تعرف سرعة الموجة (بـ متر/ثانية) والتردد (بـ هرتز)،
                  يمكنك حساب الطول الموجي (بـ متر) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الطول الموجي = سرعة الموجة / التردد</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد التردد بمعلومية سرعة الموجة والطول الموجي
                </h2>
                <p>
                  إذا كنت تعرف سرعة الموجة (بـ متر/ثانية) والطول الموجي (بـ
                  متر)، يمكنك حساب التردد (بـ هرتز) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>التردد = سرعة الموجة / الطول الموجي</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد سرعة الموجة بمعلومية الطول الموجي والتردد
                </h2>
                <p>
                  إذا كنت تعرف الطول الموجي (بـ متر) والتردد (بـ هرتز)، يمكنك
                  حساب سرعة الموجة (بـ متر/ثانية) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>سرعة الموجة = الطول الموجي × التردد</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات المتعلقة بالموجات.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div className="d-flex flex-row mb-2">
                      <div>
                        <input
                          type="radio"
                          id="calculateWavelength"
                          name="calculationMode"
                          value="calculateWavelength"
                          checked={calculationMode === "calculateWavelength"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateWavelength" className="ms-2">
                          حساب الطول الموجي
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateFrequency"
                          name="calculationMode"
                          value="calculateFrequency"
                          checked={calculationMode === "calculateFrequency"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateFrequency" className="ms-2">
                          حساب التردد
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateWaveSpeed"
                          name="calculationMode"
                          value="calculateWaveSpeed"
                          checked={calculationMode === "calculateWaveSpeed"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateWaveSpeed" className="ms-2">
                          حساب سرعة الموجة
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculateWavelength" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="waveSpeedInput"
                        >
                          سرعة الموجة (متر/ثانية)
                        </label>
                      </b>
                      <input
                        id="waveSpeedInput"
                        type="number"
                        placeholder="300"
                        value={waveSpeed}
                        onChange={handleWaveSpeedChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateFrequency" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="wavelengthInput"
                        >
                          الطول الموجي (متر)
                        </label>
                      </b>
                      <input
                        id="wavelengthInput"
                        type="number"
                        placeholder="0.5"
                        value={wavelength}
                        onChange={handleWavelengthChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateWaveSpeed" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="frequencyInput"
                        >
                          التردد (هرتز)
                        </label>
                      </b>
                      <input
                        id="frequencyInput"
                        type="number"
                        placeholder="600"
                        value={frequency}
                        onChange={handleFrequencyChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculateWavelength" &&
                          wavelength !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الطول الموجي (متر): {wavelength} متر
                            </p>
                          )}
                        {calculationMode === "calculateFrequency" &&
                          frequency !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              التردد (هرتز): {frequency} هرتز
                            </p>
                          )}
                        {calculationMode === "calculateWaveSpeed" &&
                          waveSpeed !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              سرعة الموجة (متر/ثانية): {waveSpeed} متر/ثانية
                            </p>
                          )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default WaveCalculator;
